import React from 'react';
import { ShowIf } from '@apply/components';
import { PaymentPurpose } from './components/PaymentPurpose';
import { PropertyOrLoanIdentifier } from './components/PropertyOrLoanIdentifier';
import { PaymentAmount } from './components/PaymentAmount';
import { useCustomPaymentAmount, useCustomPaymentPurpose } from '../../../../fields/CustomPaymentFields';
import { CustomPaymentPurposeType } from '../../../../constants/CustomPaymentPurposeType';
import { TransactionFee } from './components/TransactionFee';
import { TotalAmount } from './components/TotalAmount';

interface TransactionDetailsProps {
    customPaymentId: string;
}

export const TransactionDetails: React.FC<TransactionDetailsProps> = ({ customPaymentId }) => {
    const [paymentPurpose] = useCustomPaymentPurpose(customPaymentId);
    const [amount] = useCustomPaymentAmount(customPaymentId);
    const transactionFee = (amount ?? 0) * 0.03;

    return (
        <>
            <div
                className='pageSubHeader'
                style={{ marginTop: 30 }}
            >
                Additional Info
            </div>
            <div className='customPayment-transactionDetails'>
                <PaymentPurpose customPaymentId={customPaymentId} />
                <PropertyOrLoanIdentifier customPaymentId={customPaymentId} />
                <PaymentAmount customPaymentId={customPaymentId} />

                <ShowIf showIf={paymentPurpose == CustomPaymentPurposeType.InterestOrExtension}>
                    <TransactionFee fee={transactionFee} />
                    <TotalAmount
                        customPaymentId={customPaymentId}
                        fee={transactionFee}
                    />
                </ShowIf>
            </div>
        </>
    );
};
